import { gql } from '@apollo/client';

export const GET_HOST_TYPE = gql`
  query hostTypes {
    hostTypes {
      id
    }
  }
`;

export const SET_SERVICE_MODE = gql`
  mutation setServiceMode($id: Int!, $flag: FlagInput!) {
    setHostServiceMode(id: $id, input: $flag) {
      id
      in_service
      alias
    }
  }
`;

export const SEND_WAKE_PACKET = gql`
  mutation sendWakePacket($input: SendWakePacketInput!) {
    sendWakePacket(input: $input)
  }
`;

export const SEND_WAKE_PACKETS = gql`
  mutation sendWakePackets($input: SendWakePacketsInput!) {
    sendWakePackets(input: $input)
  }
`;

export const DELETE_HOST_GROUP = gql`
  mutation deleteHostGroup($id: Int!) {
    deleteHostGroup(id: $id) {
      id
      title
    }
  }
`;

export const DELETE_HOST = gql`
  mutation deleteHost($id: Int!) {
    deleteHost(id: $id) {
      id
      alias
      in_service
    }
  }
`;

export const REDEEM_BOOKING = gql`
  mutation redeemBooking($id: Int!) {
    setBookingStatus(id: $id, status: REDEEMED) {
      id
    }
  }
`;

export const MOVE_HOSTS = gql`
  mutation moveHosts($input: [HostsInput!]!) {
    updateHosts(input: $input)
  }
`;

export const START_CLIENT_SESSION = gql`
  mutation startClientSession($input: StartClientSessionInput!) {
    startClientSession(input: $input) {
      status
      hosts {
        host {
          alias
        }
      }
    }
  }
`;

export const AUTHENTICATE_SHELL_CLIENT = gql`
  mutation authenticateShellClient($hostId: Int!, $clientUuid: String!) {
    authenticateShellClient(hostId: $hostId, clientUuid: $clientUuid) {
      id
      user {
        uuid
        nickname
        phone
      }
    }
  }
`;

export const GET_HOSTS_FOR_GAME_ACCOUNTS = gql`
  query hosts {
    hosts {
      group_id
      id
      alias
      position
    }
    hostGroups {
      id
      title
    }
  }
`;

export const HOSTS_MAC_ADDRESSES = gql`
  query hosts {
    hostOverview(id: $id) {
      mac_addr
    }
  }
`;

export const CREATE_HOST_PIN = gql`
  mutation CreateHostPIN($hostId: Int!) {
    createHostPIN(hostId: $hostId)
  }
`;

export const GENERATE_QR = gql`
  mutation GenerateQR($input: GenerateQRInput!) {
    generateQR(input: $input)
  }
`;

export const CREATE_HOST_COMMAND_TEMPLATE = gql`
  mutation CreateHostCommandTemplate($input: CreateHostCommandTemplateInput!) {
    createHostCommandTemplate(input: $input) {
      arguments
      id
      path
      title
    }
  }
`;

export const UPDATE_HOST_COMMAND_TEMPLATE = gql`
  mutation UpdateHostCommandTemplate($input: UpdateHostCommandTemplateInput!) {
    updateHostCommandTemplate(input: $input) {
      arguments
      id
      path
      title
    }
  }
`;

export const DELETE_HOST_COMMAND_TEMPLATE = gql`
  mutation DeleteHostCommandTemplate($id: Int!) {
    deleteHostCommandTemplate(id: $id)
  }
`;

export const GET_HOST_COMMAND_TEMPLATES = gql`
  query HostCommandTemplates {
    hostCommandTemplates {
      arguments
      id
      path
      title
    }
  }
`;
